import actions from '../action/gift'
import CONSTANT from '../constant/gift'
export default {
    actions,
    state: {
        orderList: {
            list: [],
            total: 0
        },
        // 礼物删除操作
        IsShowGiftProduct: false,
        // 礼物生成按钮是否diaabled
        IsSumbitBtnDisabled: true,
        // 存储的礼物数据
        giftSessionData: {
            giftText: '',
            coverUrl: '',
            voiceUrl: '',
            bannerId: null
        },
        sku:{}
    },
    getters: {

    },
    mutations: {
        [CONSTANT.GIFT_GETGIFTORDERLIST_SUCCESS] (state, data) {
            state.orderList = { list: data.list, total: data.page.total }
        },
        [CONSTANT.GIFT_GETGIFTORDERLIST_ERROR] (state, e) {
            state.orderList = { list: [], total: 0}
        },
        [CONSTANT.GIFT_GETGIFTORDERDETAIL_SUCCESS] (state, data) {

        },
        [CONSTANT.GIFT_GETGIFTORDERDETAIL_ERROR] (state, e) {
        },
        [CONSTANT.GIFT_RECEIVEGIFT_SUCCESS] (state, data) {

        },
        [CONSTANT.GIFT_RECEIVEGIFT_ERROR] (state, e) {
        },
        [CONSTANT.GIFT_GETGIFTreceiveINFO_SUCCESS] (state, data) {

        },
        [CONSTANT.GIFT_GETGIFTreceiveINFO_ERROR] (state, e) {
        },
        // 跨级删除商品
        [CONSTANT.GIFT_DELETE_PRODUCTS](state, data){
            state.IsShowGiftProduct = data
            state.IsSumbitBtnDisabled = !data
        },
        // 跨级设置礼物数据
        [CONSTANT.GIFT_SET_INFO](state, data){
            state.giftSessionData = {...data}
        },
        [CONSTANT.GIFT_SET_SKU_INFO](state, data){
            state.sku = {...data}
            state.IsSumbitBtnDisabled = false
        }
        /*yeoman-template-point-1*/



    }
}
